import { ThinkModelComponent } from './../../../model/fitup/generic.model';
import { Component, OnInit, inject } from '@angular/core';
import { FitupService } from '../../../service/fitup/fitup.service';

interface AppMenu {
  attributes: {
    Children: any;
    createdAt: string;
    feature: string;
    path: string;
    publishedAt: string;
    title: string;
    type: string;
    updatedAt: string;
  }
}

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {
  private readonly _fitUpSvc = inject(FitupService)
  private appMenuComponent?: ThinkModelComponent
  public openSide: boolean = false;
  public activeItem: string | undefined = 'home';
  public activeChildItem: string | undefined = ''
  public link?: string;
  public appMenu?: AppMenu[];

  constructor() { }

  ngOnInit(): void {
    this.getDados()
  }

  getDados(): void {
    this._fitUpSvc.getStrapiDataObservable().subscribe(updateData => {
      this.appMenuComponent = updateData
      const component = this._fitUpSvc.getComponentData('app_modern_nav').data.attributes
      this.appMenu = component.app_menus.data
      this.link = component.link
    })
  }

  toggleSidebar(): void {
    this.openSide = !this.openSide
  }

  closeOverlay(): void {
    this.openSide = false
  }

  //For Active Main menu in Mobile View
  setActive(menuItem: string | undefined): void {
    if (this.activeItem === menuItem) {
      this.activeItem = ''
    } else {
      this.activeItem = menuItem
    }
  }

  isActive(item: string | undefined): boolean {
    return this.activeItem === item
  }

  // For Active Child Menu in Mobile View
  setChildActive(subMenu: string | undefined): void {
    if (this.activeChildItem === subMenu) {
      this.activeChildItem = ''
    } else {
      this.activeChildItem = subMenu
    }
  }

  ischildActive(subMenu: string | undefined): boolean {
    return this.activeChildItem === subMenu
  }
}
